import type { Package } from '@/api/billing'
import { isCampaign } from './packagePresentation'
export function usePackageVisibility() {
  function visible(items: Package[]) {
    const campaignActive = items.some(p => p.active && isCampaign(p))
    return items.filter(p => p.active && p.code.startsWith('TOPUP_') && (!campaignActive || !(p.hideDuringCampaign ?? !isCampaign(p))))
      .sort((a,b) => Number(b.recommended)-Number(a.recommended) || a.sortOrder-b.sortOrder || a.priceFen-b.priceFen || a.id.localeCompare(b.id))
  }
  function status(p: Package, items: Package[]) {
    if (!p.active) return '不展示（未上架）'
    return visible(items).some(item => item.code === p.code) ? '用户端展示' : '活动期间隐藏'
  }
  return { visible, status }
}
